import React, { useEffect } from 'react';
import { DigitalCase, DigitalSection, FaerbungReviewMeta } from '../../redux/types';
import { useAppDispatch } from '../reduxHooks';
import { addUpdateFaerbungReviewMetas } from '../../redux/actions/faerbungReviewAction';

/**
   * This hook auto-updates the FaerbungReviewMeta.maxScore based on the following if:
   * Cases are updated (add/delete)
   * Category score is updated
   */
const useUpdateMaxFaerbungScores = (
  allCases: DigitalCase[],
  selectedSection: DigitalSection,
  selectedFaerbungReviewMeta?: FaerbungReviewMeta,
): void => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!selectedFaerbungReviewMeta) {
      return;
    }
    const selectedSectionCases = allCases.filter((c) => c.digitalSectionId === selectedSection.id);
    const maxScorePerCategory = selectedFaerbungReviewMeta.categories.map((cat) => (
      cat.score * selectedSectionCases.length
    ));
    const maxScore = maxScorePerCategory.reduce((a, c) => (a + c), 0);
    if (maxScore === selectedFaerbungReviewMeta.maxScore) {
      return;
    }
    dispatch(addUpdateFaerbungReviewMetas([{
      ...selectedFaerbungReviewMeta,
      maxScore,
    }]));
  }, [selectedFaerbungReviewMeta, allCases, selectedSection.id, dispatch]);
};

export default useUpdateMaxFaerbungScores;
